'use strict'

/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */

// 3rd party
import React from 'react'

// lib
import Box, { BoxProps } from '@components/kit/box'
import Circle from '@components/kit/circle'
import Text from '@components/kit/text'

/* -----------------------------------------------------------------------------
 * MemberAvatar
 *
 * A member's initials in a green circle, as the old kit's Avatar drew them for
 * the member list and the room: members never have a photo here. Style props
 * go to the Box around the circle.
 * -------------------------------------------------------------------------- */

const initialsOf = (name: string) =>
  name
    .split(' ')
    .map(word => word[0])
    .slice(0, 2)
    .join('')

export type MemberAvatarProps = BoxProps & {
  name: string
  size?: number
}

function MemberAvatar({ name, size = 32, ...rest }: MemberAvatarProps) {
  return (
    <Box {...rest}>
      <Circle size={size} bg='everestGreen'>
        <Text variant='label' fontSize={size <= 24 ? 8 : 12} textColor='white'>
          {initialsOf(name)}
        </Text>
      </Circle>
    </Box>
  )
}

export default MemberAvatar
